<script setup lang="ts">
import BrandColors from '@pocketprep/ui-kit/pocketprep-export.module.scss'
import { ref, watch } from 'vue'

const props = defineProps<{
    isDarkMode?: boolean
    isActive: boolean
    isHover: boolean
}>()

const stroke = ref(props.isDarkMode ? BrandColors.ash : BrandColors.cloudy)
const fillOpacity = ref(0)
const fill = ref(BrandColors.buttermilk)

const updateColors = () => {
    stroke.value = props.isDarkMode ? BrandColors.ash : BrandColors.cloudy
    fill.value = BrandColors.buttermilk
    fillOpacity.value = 0

    if (props.isHover) {
        if (props.isDarkMode) {
            stroke.value = BrandColors.brandBlue
        } else {
            stroke.value = BrandColors.bananaBread
        }
    }
    if (props.isActive) {
        if (props.isDarkMode) {
            stroke.value = BrandColors.brandBlue
            fillOpacity.value = 0.4
            fill.value = BrandColors.brandBlue
        } else {
            stroke.value = BrandColors.grayBackground
            fillOpacity.value = 0.45
            fill.value = BrandColors.cloudy
        }
    }
}

watch(props, () => {
    updateColors()
})
</script>

<!-- eslint-disable -->
<template>
    <div class="save">
        <svg class="save__icon" width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="save__icon-path" d="M2 0.75H10C10.6904 0.75 11.25 1.30964 11.25 2V16.3984L6.48047 12.4248L6 12.0254L5.51953 12.4248L0.75 16.3984V2C0.75 1.30964 1.30964 0.75 2 0.75Z" :fill="fill" :fill-opacity="fillOpacity" :stroke="stroke" stroke-width="1.5"/>
        </svg>
    </div>
</template>
<!-- eslint-enable -->
<style lang="scss" scoped>
.save {
    height: 18px;
}
</style>
